import React from "react";
import "../../../styles/globalStyles.css";
import styles from "./Web.module.css";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Package() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);
  const [hoveredColumn, setHoveredColumn] = useState(null);

  const hoverClasses = [
    styles.hoverColumnHeading,
    styles.hoverColumn,
    styles.hoverColumnCream,
    styles.hoverColumnOrange
  ];

  const getColumnHoverClass = (index) =>
    hoveredColumn === index ? hoverClasses[index] : "";

return (
  <section id="packages" className={"light"}>
    <div className={styles.planContainer}>
      <table className={styles.planTable}>
        <thead>
          <tr>
            <th
              className={getColumnHoverClass(0)}
              onMouseEnter={() => setHoveredColumn(0)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              Pakiet
            </th>
            <th
              className={getColumnHoverClass(1)}
              onMouseEnter={() => setHoveredColumn(1)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              „Wizytówka”
            </th>
            <th
              className={getColumnHoverClass(2)}
              onMouseEnter={() => setHoveredColumn(2)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              „Standard”
            </th>
            <th
              className={getColumnHoverClass(3)}
              onMouseEnter={() => setHoveredColumn(3)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              „Premium”
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              className={getColumnHoverClass(0)}
              onMouseEnter={() => setHoveredColumn(0)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              Cena
            </th>
            <td
              className={getColumnHoverClass(1)}
              onMouseEnter={() => setHoveredColumn(1)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              od 1800 zł
            </td>
            <td
              className={getColumnHoverClass(2)}
              onMouseEnter={() => setHoveredColumn(2)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              od 3500 zł
            </td>
            <td
              className={getColumnHoverClass(3)}
              onMouseEnter={() => setHoveredColumn(3)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              od 4900 zł
            </td>
          </tr>
          <tr>
            <th
              className={getColumnHoverClass(0)}
              onMouseEnter={() => setHoveredColumn(0)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <span className={styles.headingRangePackage}>
                W ramach pakietu
              </span>
            </th>
            <td
              className={getColumnHoverClass(1)}
              onMouseEnter={() => setHoveredColumn(1)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <ul>
                <li>indywidualny projekt graficzny strony</li>
                <li>pełna responsywność</li>
                <li>do 5 podstron</li>
                <li>formularz kontaktowy</li>
                <li>integracja z mapami Google</li>
                <li>przygotowanie i wdrożenie "Polityki prywatności"*</li>
                <li>
                  przygotowanie informacji o wykorzystywaniu plików cookie
                </li>
                <li>podstawowa optymalizacja SEO</li>
                <li>konfiguracja domeny i hostingu**</li>
                <li>wdrożenie strony</li>
              </ul>
            </td>
            <td
              className={getColumnHoverClass(2)}
              onMouseEnter={() => setHoveredColumn(2)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <ul>
                <li>wszystko z pakietu "Wizytówka"</li>
                <li>do 10 podstron</li>
                <li>rozbudowana treść i struktura strony</li>
                <li>animacje i elementy interaktywne</li>
                <li>integracje z mediami społecznościowymi</li>
              </ul>
            </td>
            <td
              className={getColumnHoverClass(3)}
              onMouseEnter={() => setHoveredColumn(3)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <ul>
                <li>wszystko z pakietu "Standard"</li>
                <li>indywidualna analiza potrzeb i warsztaty</li>
                <li>powyżej 10 podstron</li>
                <li>zaawansowana optymalizacja SEO (techniczna + treściowa)</li>
                <li>
                  podstawowe integracje (np. newsletter, social media, Google
                  Tag Manager)
                </li>
                <li>
                  niestandardowe i zaawansowane integracje wyceniane
                  indywidualnie po warsztatach***
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              className={getColumnHoverClass(0)}
              onMouseEnter={() => setHoveredColumn(0)}
              onMouseLeave={() => setHoveredColumn(null)}
            ></td>
            <td
              className={getColumnHoverClass(1)}
              onMouseEnter={() => setHoveredColumn(1)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <Link to="/#contact" className={styles.buyButton}>
                Poproś o wycenę
              </Link>
            </td>
            <td
              className={getColumnHoverClass(2)}
              onMouseEnter={() => setHoveredColumn(2)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <Link to="/#contact" className={styles.buyButton}>
                Poproś o wycenę
              </Link>
            </td>
            <td
              className={getColumnHoverClass(3)}
              onMouseEnter={() => setHoveredColumn(3)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <Link to="/#contact" className={styles.buyButton}>
                Poproś o wycenę
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    {/* ---------------------------------------------------------- */}

    <div className={styles.planCard}>
      <div className={styles.planCardItemGreen}>
        <div className={styles.planCardHeading}>
          <h2>Wizytówka</h2>
        </div>
        <div className={styles.planCardPrice}>
          <p>od 1800 zł</p>
        </div>
        <div className={styles.planCardRange}>
          <ul className={styles.rangeOfPackage}>
            <li>indywidualny projekt graficzny strony</li>
            <li>pełna responsywność</li>
            <li>do 5 podstron</li>
            <li>formularz kontaktowy</li>
            <li>integracja z mapami Google</li>
            <li>przygotowanie i wdrożenie "Polityki prywatności"*</li>
            <li>przygotowanie informacji o wykorzystywaniu plików cookie</li>
            <li>podstawowa optymalizacja SEO</li>
            <li>konfiguracja domeny i hostingu**</li>
            <li>wdrożenie strony</li>
          </ul>
        </div>
        <div className={styles.buttonContainerGreen}>
          <Link to="/#contact" className={styles.assessmentButton}>
            Poproś o wycenę
          </Link>
        </div>
      </div>
      <div className={styles.planCardItemCream}>
        <div className={styles.planCardHeading}>
          <h2>Standard</h2>
        </div>
        <div className={styles.planCardPrice}>
          <p>od 3500 zł</p>
        </div>
        <div className={styles.planCardRange}>
          <ul className={styles.rangeOfPackage}>
            <li>Wszystko z pakietu "Wizytówka"</li>
            <li>do 10 podstron</li>
            <li>rozbudowana treść i struktura strony</li>
            <li>animacje i elementy interaktywne</li>
            <li>integracje z mediami społecznościowymi</li>
          </ul>
        </div>
        <div className={styles.buttonContainerCream}>
          <Link to="/#contact" className={styles.assessmentButton}>
            Poproś o wycenę
          </Link>
        </div>
      </div>
      <div className={styles.planCardItemOrange}>
        <div className={styles.planCardHeading}>
          <h2>Premium</h2>
        </div>
        <div className={styles.planCardPrice}>
          <p>od 4900 zł</p>
        </div>
        <div className={styles.planCardRange}>
          <ul className={styles.rangeOfPackage}>
            <li>Wszystko z pakietu "Standard"</li>
            <li>indywidualna analiza potrzeb i warsztaty</li>
            <li>powyżej 10 podstron</li>
            <li>zaawansowana optymalizacja SEO (techniczna + treściowa)</li>
            <li>
              podstawowe integracje (np. newsletter, social media, Google Tag
              Manager)
            </li>
            <li>
              niestandardowe i zaawansowane integracje wyceniane indywidualnie
              po warsztatach***
            </li>
          </ul>
        </div>
        <div className={styles.buttonContainerOrange}>
          <Link to="/#contact" className={styles.assessmentButton}>
            Poproś o wycenę
          </Link>
        </div>
      </div>
    </div>

    <div className={styles.comment}>
      <p>
        * Jako firma ArtKoz nie świadczymy usług prawnych. Dokumenty (polityka
        prywatności, cookies, regulaminy) przygotowujemy jako element techniczny
        wdrożenia. Klient ponosi odpowiedzialność za ich merytoryczną treść.
      </p>
      <p>
        ** Domena, hosting, certyfikat SSL i inne związane z tym koszty nie są
        wliczone w cenę pakietu.
      </p>
      <p>
        *** Zaawansowane integracje z systemami zewnętrznymi (np. CRM, bramki
        płatnicze, API firm trzecich, systemy rezerwacji) są wyceniane
        indywidualnie po przeprowadzeniu analizy potrzeb.
      </p>
      <p>
        <strong>Zasadny rozliczania</strong>
        <br />
        Ceny wskazane przy pakietach mają charakter orientacyjny i stanowią ceny
        wyjściowe za realizację zakresu prac określonego w danym pakiecie.
        Ostateczna cena zależy od szczegółowych ustaleń dotyczących projektu.
        Prace wykraczające poza zakres danego pakietu podlegają dodatkowej
        wycenie i są rozliczane według stawki godzinowej lub na podstawie
        indywidualnie ustalonego wynagrodzenia.
      </p>
    </div>
  </section>
);
}